import {
  AppShell,
  Badge,
  Box,
  Group,
  Menu,
  Stack,
  Text,
  Title,
} from '@mantine/core'
import BlueCardMark from '@assets/bluecardMark.svg'
import BlueCardName from '@assets/bluecardName.svg'
import ExampleLocation from '@assets/exampleLocation.png'
import classes from './ShellNavigation.module.css'
import { useAppSelector } from '@hooks/redux'
import {
  selectActiveLocation,
  selectActiveSection,
} from '@redux/site/siteSlice'
import {
  IconActivity,
  IconBuildingCommunity,
  IconChevronRight,
  IconFile,
  IconNotes,
  IconPhoneCall,
  IconSubtask,
} from '@tabler/icons-react'
import cn from 'classnames'
import { useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import { NavFooter } from '@components/NavFooter/NavFooter'

export interface ShellNavigationProps {
  toggleAside: () => void
}

export const ShellNavigation = (props: ShellNavigationProps) => {
  const navigate = useNavigate()
  const activeSection = useAppSelector(selectActiveSection)
  const activeLocation = useAppSelector(selectActiveLocation)

  const handleMarkClick = () =>
    navigate(`${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`)

  const MOCK_LOCATIONS = [
    'PS 122',
    `Children's Aid NYC`,
    'Brooklyn Public Library',
  ]

  return (
    <>
      <AppShell.Section grow>
        <Stack gap={0}>
          <Group
            px="md"
            py="xl"
            gap="xs"
            align="center"
            onClick={handleMarkClick}
            style={{ cursor: 'pointer' }}
          >
            <img src={BlueCardMark} height={25} />
            <img src={BlueCardName} height={18} />
          </Group>
          <Menu
            position="right-start"
            shadow="xs"
            offset={{
              mainAxis: 3,
              crossAxis: 0,
            }}
          >
            <Menu.Target>
              <Box className={classes.ShellNavigation__activeLocation} p="sm">
                <Group gap="sm" wrap="nowrap">
                  <img
                    className={classes.ShellNavigation__img}
                    src={ExampleLocation}
                    width={45}
                    height={45}
                  />
                  <Text
                    size="lg"
                    fw="bold"
                    c="white"
                    style={{ flexGrow: 1 }}
                    truncate
                  >
                    {activeLocation.name}
                  </Text>
                  <IconChevronRight
                    color="var(--mantine-color-navbar-blue-1)"
                    size={28}
                    style={{ flexShrink: 0 }}
                  />
                </Group>
              </Box>
            </Menu.Target>
            <Menu.Dropdown miw={175}>
              <Menu.Label>Locations</Menu.Label>
              <Menu.Divider />
              {MOCK_LOCATIONS.map((location, i) => {
                console.log(location, activeLocation)
                return (
                  <Menu.Item
                    c={activeLocation.name === location ? 'blue' : 'dark.7'}
                    key={`active-location-${i}`}
                  >
                    <Text
                      size="sm"
                      fw={activeLocation.name === location ? 'bold' : 'normal'}
                    >
                      {location}
                    </Text>
                  </Menu.Item>
                )
              })}
            </Menu.Dropdown>
          </Menu>
          <Stack gap={0} mt="lg">
            <Group
              px="lg"
              py="xs"
              gap="xs"
              align="center"
              onClick={() =>
                navigate(
                  `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`,
                )
              }
              className={cn(classes.ShellNavigation__navItem, {
                [classes.ShellNavigation__navItemActive]:
                  activeSection === 'Community',
              })}
            >
              <IconBuildingCommunity size={22} />
              <Title order={5}>Community</Title>
            </Group>
            <Group
              px="lg"
              py="xs"
              gap="xs"
              align="center"
              onClick={() => navigate(RoutePaths.TASKS)}
              className={cn(classes.ShellNavigation__navItem, {
                [classes.ShellNavigation__navItemActive]:
                  activeSection === 'Tasks',
              })}
            >
              <IconSubtask size={22} />
              <Title order={5}>Tasks</Title>
              <Badge color="orange.6" size="sm">
                2
              </Badge>
            </Group>
            <Group
              px="lg"
              py="xs"
              gap="xs"
              align="center"
              onClick={() => navigate(RoutePaths.CALLS)}
              className={cn(classes.ShellNavigation__navItem, {
                [classes.ShellNavigation__navItemActive]:
                  activeSection === 'Calls',
              })}
            >
              <IconPhoneCall size={22} />
              <Title order={5}>Calls</Title>
            </Group>
            <Group
              px="lg"
              py="xs"
              gap="xs"
              align="center"
              onClick={() => navigate(RoutePaths.NOTES)}
              className={cn(classes.ShellNavigation__navItem, {
                [classes.ShellNavigation__navItemActive]:
                  activeSection === 'Notes',
              })}
            >
              <IconNotes size={22} />
              <Title order={5}>Notes</Title>
            </Group>
            <Group
              px="lg"
              py="xs"
              gap="xs"
              align="center"
              onClick={() => navigate(RoutePaths.FILES)}
              className={cn(classes.ShellNavigation__navItem, {
                [classes.ShellNavigation__navItemActive]:
                  activeSection === 'Files',
              })}
            >
              <IconFile size={22} />
              <Title order={5}>Files</Title>
            </Group>
            <Group
              px="lg"
              py="xs"
              gap="xs"
              align="center"
              onClick={() => navigate(RoutePaths.ACTIVITY)}
              className={cn(classes.ShellNavigation__navItem, {
                [classes.ShellNavigation__navItemActive]:
                  activeSection === 'Activity',
              })}
            >
              <IconActivity size={22} />
              <Title order={5}>Activity</Title>
            </Group>
          </Stack>
        </Stack>
      </AppShell.Section>
      <NavFooter />
    </>
  )
}
